interface IGetCurrentSubdomainResult {
    isFACCM: boolean;
    subdomain: string;
}

export const getCurrentSubdomain = (): IGetCurrentSubdomainResult => {
    const subdomain = window.location.hostname.split('.')[0];

    return {
        isFACCM: subdomain === 'faccmapp',
        subdomain,
    };
};
